export var getBoundryRange = function getBoundryRange(isShowingPageNumbers) {
  return isShowingPageNumbers ? 1 : 10;
};